var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.614 4.348a.422.422 0 0 0-.365.209l-4.278 7.23a.422.422 0 0 0 .365.634h3.197l-1.47 5.742a.422.422 0 0 0 .707.405l8.999-8.98a.422.422 0 0 0-.3-.719h-4.087l2.403-3.877a.421.421 0 0 0-.36-.644H9.613z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBlack);
export default __webpack_public_path__ + "static/media/lightningBlack.4911e7b253add1fc8072047f6aa7168c.svg";
export { ForwardRef as ReactComponent };